// extracted by mini-css-extract-plugin
export default {"app_policy":"ShippingPolicy_app_policy__mrfL1"};